/**
* Column Accordion JS
* -----------------------------------------------------------------------------
*
* All the JS for the Column Accordion component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'column-accordion',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      setAccordionHeight( 'column-acocordion__container' );
      function setAccordionHeight( className ) {
        const $elements = $( `.${className}` );
        let maxHeight = 0;

        $elements.each( function() {
          const elementHeight = $( this ).outerHeight();
          if ( elementHeight > maxHeight ) {
            maxHeight = elementHeight;
          }
        } );
        $elements.css( 'min-height', `${maxHeight}px` );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'column-accordion', COMPONENT );
} )( app );
